import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { CardMeliUpload } from "../../components/forms/CardMeliUpload";
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import { PodCopy } from "../../assets/Podcast/PodCopy";

const StyleCss = styled.div`
  .content {
    padding: 0 0.5rem;
  }
`;

export const Documents_Query = gql`
  query DocumentsQuery{
    getDocuments{
      _id
      User
      tag
      Address
      status
      description
    }
  }
`


function WorkPageDocuments(props) {
  const documents = useQuery(Documents_Query, {
    fetchPolicy: "network-only"
  });
  if(documents.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
          <div className="title">
            <div className="icon"><PodCopy/></div>
            <div className="text">Documents</div>
          </div>
        </div>
        <div className="content">
          <Loading/>
        </div>
      </StyleCss>
    )
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodCopy/></div>
            <div className="text">Documents</div>
          </div>
      </div>
      <div className="content">
        <CardMeliUpload 
          {...props} 
          type={"NationalCard"} 
          title={"National Card"}
          data={documents.data.getDocuments}
        />
        <CardMeliUpload 
          {...props} 
          type={"NationalPaper"} 
          title={"National Paper"}
          data={documents.data.getDocuments}
        />
        <CardMeliUpload 
          {...props} 
          type={"EducationDoc"} 
          title={"Last Education Document"}
          data={documents.data.getDocuments}
        />
      </div>
    </StyleCss>
  )
}
export default WorkPageDocuments;